module.exports = __webpack_public_path__ + "static/dm-1-a21fb4bea06bb8d8456fce001a07214b.svg";